import {useEffect, useRef} from "react";
import {FiX} from "react-icons/fi";

import {useZendeskMessenger} from "@/components/context/hooks.ts";
import {IconButton} from "@/components/iconButton/IconButton.tsx";
import {renderZendeskMessengerEmbedded} from "@/lib/integrations/zendesk.ts";

import styles from "./ZendeskMessenger.module.scss";

const TARGET_ID = "uptime-zendesk-messenger-host";

export const ZendeskMessenger = () => {
  const {isOpen, close} = useZendeskMessenger();
  const renderedRef = useRef(false);

  useEffect(() => {
    if (renderedRef.current) return;
    renderedRef.current = renderZendeskMessengerEmbedded(`#${TARGET_ID}`);
  }, []);

  return (
    <div className={isOpen ? styles.visible : styles.hidden} aria-hidden={!isOpen}>
      <IconButton
        icon={FiX}
        size={"fitIcon"}
        variant={"ghost"}
        className={styles.closeBtn}
        aria-label={"Close support messenger"}
        onClick={close}
      />
      <div id={TARGET_ID} className={styles.host} />
    </div>
  );
};
